import { render } from "./SpecificationRadio.vue?vue&type=template&id=6f76a8c5"
import script from "./SpecificationRadio.vue?vue&type=script&lang=js"
export * from "./SpecificationRadio.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bomo-staging/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__